import React from 'react'
import {TimeStream} from '../../../utils'


export default class InviteList extends React.Component {
    render() {
        let records = this.props.records
        return (
            <div className="invite-list">
                <div className="invite-list-header">
                    <div className="invite-list-header__title">
                        <span className="invite-list-header__line"/>
                        {records && records.length > 0 ?
                            <span className="invite-list-header__text">已获得赠送课程</span>
                            :
                            <span className="invite-list-header__text">暂无赠送课程</span>
                        }
                        <span className="invite-list-header__line"/>
                    </div>
                    {records && records.length > 0 ?
                        <div className="invite-list-header__tips">还没获得奖励，快送好友听课程</div>
                        :
                        <div className="invite-list-header__tips">还没有获得奖励，分享当前页给好友，一起领课</div>
                    }
                </div>
                <div className="invite-list-content">
                    {records && records.length > 0 && records.map((item, index) => {
                        return (<div className="invite-list-item" key={index}>
                            <div className="invite-list-item__avatar fl">
                                <img src={item.account.small_avatar_url}/>
                            </div>
                            <div className="invite-list-item__content fl text-ellipsis">
                                <p className="invite-list-item__title text-ellipsis">{item.account.nickname}成功领取{item.channel_name}，你也同时获得该课程</p>
                                <p className="invite-list-item__time">{TimeStream(item.accept_timestamp)}</p>
                            </div>
                        </div>)
                    })}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteList.js